const CLOUDFLARE_ERROR_CODE_PATTERN = /error code:\s*(\d+)/i;

export function parseCloudflareErrorCode(body: string): string | null {
  const match = body.match(CLOUDFLARE_ERROR_CODE_PATTERN);
  return match?.[1] ?? null;
}
